import OrderItemLabelTemplateDTO from "@/dto/template/OrderItemLabelTemplateDTO";
import PackingListTemplateDTO from "@/dto/template/PackingListTemplateDTO";
import WaybillTemplateDTO from "@/dto/template/WaybillTemplateDTO";

export default function (template: WaybillTemplateDTO | PackingListTemplateDTO | OrderItemLabelTemplateDTO) {
    return !!template?.fields?.find(({ key }) => key === "sequenceNo")
}